import { useQuery } from "@tanstack/react-query";
import { getSettings } from "../api/settings";

export const SITE_NAME_FALLBACK = "Probate Divorce";

// Shared hook that returns the platform's display name pulled from the public
// admin-settings API. Cached globally via React Query so there's at most one
// network call across the entire SPA.
export function useSiteName() {
  const { data } = useQuery({
    queryKey: ["public-settings"],
    queryFn: getSettings,
    staleTime: 5 * 60 * 1000,
    retry: 1,
  });
  const name = data?.platform_name?.trim();
  return name || SITE_NAME_FALLBACK;
}
